<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { useVModel } from '@vueuse/core'
import { cn } from '@/lib/utils'
import { inputVariants, type InputVariants } from '.'

const props = defineProps<{
  variant?: InputVariants['variant']
  defaultValue?: string | number
  modelValue?: string | number
  class?: HTMLAttributes['class']
}>()

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue
})
</script>

<template>
  <input v-model="modelValue" :class="cn(inputVariants({ variant }), props.class)" />
</template>

<style lang="scss" scoped>
.input {
  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #1f1f24 inset;
    caret-color: white;

    &::first-line {
      @apply text-white;
    }
  }

  &:disabled {
    &:-webkit-autofill::first-line {
      @apply text-textInactive;
    }
  }
}

.border-error {
  @apply text-error;
  border: 1px solid;
}
</style>
